import React from "react";
import styles from "./deviceSetting.module.css";

import deviceIndicator from "./deviceIndicator.png";
import indicatorAntenna from "./indicatorAntenna.png";
import indicatorAntennaCabel from "./indicatorAntennaCabel.png";
import menuStructure from "./menuStructure.png";
import externalModem from "./externalModem.png";
import builtinModem from "./builtinModem.png";
import saveNo from "./saveNo.png";
import saveYes from "./saveYes.png";
import enterArrow from "./enterArrow.png";
import backArrow from "./backArrow.png";
import forwardArrow from "./forwardArrow.png";
import downArrow from "./downArrow.png";
import upArrow from "./upArrow.png";

class DeviceSetting extends React.Component {
  render() {
    const { detect } = require("detect-browser");
    const browser = detect();
    const firefox = browser.name === "firefox";

    return (
      <div className={styles.container} style={{marginBottom: firefox ? "3em" : "0em"}}>
        <div>
          Для всех приборов Проверить наличие питания (220В) на теплосчетчике
          (Горит ли индикация на приборе)
        </div>
        <div
          style={{
            textAlign: "center",
            width: "100%",
            paddingTop: "1em",
            paddingBottom: "1em"
          }}
        >
          <img src={deviceIndicator} width="270" height="440" alt=""/>
        </div>
        <div>
          Если используется внешний модем:
          <ul className={styles.dashed}>
            <li>
              <span style={{ paddingLeft: "0.5em" }}>
                проверить наличие питания (220В) на модеме (горит ли индикация
                на модеме)
              </span>
              <br />
              <img
                src={indicatorAntenna}
                width="315"
                height="400"
                style={{
                  marginTop: "1em",
                  marginBottom: "1em"
                }}
                alt=""
              />
              <img
                src={indicatorAntennaCabel}
                width="268"
                height="400"
                style={{
                  marginLeft: "2.5em",
                  marginTop: "1em",
                  marginBottom: "1em"
                }}
                alt=""
              />
            </li>
            <li>
              проверить что интерфейсный кабель от модема соединен с портом
              RS-232 теплосчетчика, а так же его целостность.
            </li>
            <li>
              проверить что антенна стоит на своем месте, а так же целостность
              антенного кабеля.
            </li>
          </ul>
        </div>
        <br />
        <br />
        <div style={{ textAlign: "center" }}>Настройка теплосчетчика ВИС.Т</div>
        <br />
        <div
          style={{
            textAlign: "center",
            width: "100%",
            paddingBottom: "1em"
          }}
        >
          <img src={menuStructure} />
        </div>
        <div>
          Для входа и выхода в раздел используется кнопка{" "}
          <img src={enterArrow} width="12" height="17"  alt=""/>
        </div>
        <div>
          Перемещение между разделами осуществляется кнопками{" "}
          <img src={backArrow} width="16" height="13"  alt=""/> и{" "}
          <img src={forwardArrow} width="16" height="13"  alt=""/>
        </div>
        <div>
          Перемещение между пунктами внутри раздела осуществляется кнопками{" "}
          <img src={upArrow} width="14" height="17"  alt=""/> и{" "}
          <img src={downArrow} width="14" height="17"  alt=""/>
        </div>
        <br />
        <div>
          Необходимо выйти из текущего раздела нажатием кнопки{" "}
          <img src={enterArrow} width="12" height="17"  alt=""/> чтобы попасть в меню
          выбора разделов (смотри таблицу выше)
        </div>
        <div>
          Кнопками <img src={backArrow} width="16" height="13"  alt=""/> или{" "}
          <img src={forwardArrow} width="16" height="13"  alt=""/> выбрать раздел
          «Прибор»
        </div>
        <div>
          Далее кнопкой <img src={downArrow} width="14" height="17"  alt=""/> выбрать
          пункт «настройка»
        </div>
        <div>
          1 раз нажать кнопку <img src={enterArrow} width="12" height="17"  alt=""/>{" "}
          для входа
        </div>
        <div>
          С помощью кнопки <img src={downArrow} width="14" height="17"  alt=""/>{" "}
          необходимо найти пункты следующие пункты:
        </div>
        <div>Для внешнего модема:</div>
        <div
          style={{
            textAlign: "center",
            width: "100%",
            paddingTop: "1em",
            paddingBottom: "1em"
          }}
        >
          <img src={externalModem}  alt=""/>
        </div>
        <div>
          Если один или более указанных опций не соответствуют данным значениям,
          то их необходимо установить.
        </div>
        <div>
          С помощью кнопок <img src={upArrow} width="14" height="17"  alt=""/> и{" "}
          <img src={downArrow} width="14" height="17"  alt=""/> выбрать нужный
          параметр, а кнопками <img src={backArrow} width="16" height="13"  alt=""/> и{" "}
          <img src={forwardArrow} width="16" height="13"  alt=""/> установить нужную
          опцию.
        </div>
        <br />
        <div>Для встроенного модема:</div>
        <div
          style={{
            textAlign: "center",
            width: "100%",
            paddingTop: "1em",
            paddingBottom: "1em"
          }}
        >
          <img src={builtinModem}  alt=""/>
        </div>
        <div>
          Если один или более указанных опций не соответствуют данным значениям,
          то их необходимо установить.
        </div>
        <div>
          С помощью кнопок <img src={upArrow} width="14" height="17"  alt=""/> и{" "}
          <img src={downArrow} width="14" height="17" /> выбрать нужный
          параметр, а кнопками <img src={backArrow} width="16" height="13"  alt=""/> и{" "}
          <img src={forwardArrow} width="16" height="13"  alt=""/> установить нужную
          опцию.
        </div>
        <br />
        <div>
          После того как настройки установлены нажать клавишу{" "}
          <img src={enterArrow} width="12" height="17"  alt=""/> 1 раз.
        </div>
        <div>На нижней строчке появится надпись «Сохранить нет».</div>
        <div
          style={{
            textAlign: "center",
            width: "100%",
            paddingTop: "1em",
            paddingBottom: "1em"
          }}
        >
          <img src={saveNo} width="494" height="184"  alt=""/>
        </div>

        <div>
          1 раз нажать клавишу <img src={backArrow} width="16" height="13"  alt=""/>{" "}
          или <img src={forwardArrow} width="16" height="13"  alt=""/> чтобы появилось
          «Сохранить да»
        </div>
        <div
          style={{
            textAlign: "center",
            width: "100%",
            paddingTop: "1em",
            paddingBottom: "1em"
          }}
        >
          <img src={saveYes} width="494" height="184"  alt=""/>
        </div>
        <div>
          1 раз нажать клавишу <img src={enterArrow} width="12" height="17"  alt=""/>
        </div>
      </div>
    );
  }
}

export default DeviceSetting;
